import { Plural } from '../types';

export enum Statuses {
  WAITING = 'waiting',
  READY = 'ready',
}

export interface Item {
  date: Date;
  count: number;
}

export type Items = Array<Item>;

export { Plural };



// WEBPACK FOOTER //
// ./src/components/calendar/month/types.ts